module.exports = __webpack_public_path__ + "img/iStock-506252774_super.64087a81.jpg";